// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { KLBadgeDetailsAssetByBadgeId } from '../constants/assets';
import { KLCollectibleLabelsByCollectibleId } from '../constants/labels';
import KLBadgeDetailsCardContainer from '../containers/KLBadgeDetailsCardContainer';
import { KLCollectibleId, KLCollectibleStatus, KLCollectibleStatuses } from '../types/collectible';
import { KLViewTypes } from '../types/view';

import KLViewWrapper from './common/KLViewWrapper';

const StyledKLViewWrapper = styled(KLViewWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BadgeName = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2.5em;
  padding: 0.5em 0;
`;

const BadgeWrapper = styled.div`
  height: 66%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BadgeImage = styled.img`
  max-width: 65%;
  max-height: 50%;
  padding: 0.5em 0;
`;

const DetailCardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  ${({ $status }) => {
    if ($status !== KLCollectibleStatuses.OPEN) {
      return css`
        height: 34%;
      `;
    }
  }}
`;

const StyledKLBadgeDetailsCardContainer = styled(KLBadgeDetailsCardContainer)``;

type KLBadgeDetailsProps = {
  className?: string;
  badgeId: KLCollectibleId;
  status: KLCollectibleStatus;
};

const KLBadgeDetails = ({ className, badgeId, status }: KLBadgeDetailsProps) => {
  const assetPath = useMemo(() => {
    switch (status) {
      case KLCollectibleStatuses.WON:
        return KLBadgeDetailsAssetByBadgeId[badgeId]?.won;
      case KLCollectibleStatuses.PENDING:
        return KLBadgeDetailsAssetByBadgeId[badgeId]?.pending;
      default:
        return KLBadgeDetailsAssetByBadgeId[badgeId]?.default;
    }
  }, [badgeId, status]);

  return (
    <StyledKLViewWrapper className={className} viewType={KLViewTypes.BADGE_DETAIL}>
      <BadgeWrapper>
        <BadgeName>{KLCollectibleLabelsByCollectibleId[badgeId]?.collectibleLabel}</BadgeName>
        <BadgeImage src={assetPath} />
      </BadgeWrapper>
      <DetailCardWrapper>
        <StyledKLBadgeDetailsCardContainer $status={status} badgeId={badgeId} />
      </DetailCardWrapper>
    </StyledKLViewWrapper>
  );
};

export default KLBadgeDetails;
